import { clientAxios } from '@/plugins/axios'

export const getMenuEnableinfo = () => clientAxios.get(`/v1/setting/shop/detail/menu`)
